
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model } from '../../controlador';
    import { EstadisticaVentas, Articulo } from '@/__env/lib/Articulos';
    import { WaitEntre } from '@/__env/ext';
import { Articulo } from '@/__env/lib/Articulos';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        public get Controlador() { return Model; }

        public Estado: string = '';

        @Prop( { type: Articulo } )
        public Articulo: Articulo;
        @Watch( 'Articulo', { immediate: true } )
        onEmpresa()
        {
            this.buscar();
        }

        public Items: EstadisticaVentas[] = [];
        async buscar()
        {
            await WaitEntre( 500, 1000 );
            this.Items = await EstadisticaVentas.find( { articulo: this.Articulo.Id } );
            this.Estado = 'ok';
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        async mounted()
        {

        }


    }
